export default class Account {

    constructor(obj) {

        this.id = obj['id'];
        this.clientId = obj['client_id']; //cliente dono da conta
        this.instituitionCod = obj['cod']; //código da instituição
        this.instituitionId = obj['instituition_id'];
        this.instituitionDescription = obj['description'];
        this.agency = obj['agency'];
        this.numberAccount = obj['number_account'];
        this.accountRegimeId = obj['account_regime_id'];
        this.accountInit = obj['account_init'];
        this.createdDate = obj['created_date'];
        this.modifiedDate = obj['modified_date'];

    }
}
